import moment from 'moment'

// Canonical auto-hide durations in minutes, shared with iOS/Android. 0 = never.
export const getAutoHideOptions = (t) => [
	{ id: 0, label: t('settings_hidden_groups_auto_hide_never') },
	{ id: 4320, label: t('settings_hidden_groups_auto_hide_3_days') },
	{ id: 10080, label: t('settings_hidden_groups_auto_hide_7_days') },
	{ id: 20160, label: t('settings_hidden_groups_auto_hide_14_days') },
	{ id: 43200, label: t('settings_hidden_groups_auto_hide_30_days') },
	{ id: 129600, label: t('settings_hidden_groups_auto_hide_90_days') },
	{ id: 262800, label: t('settings_hidden_groups_auto_hide_6_months') },
	{ id: 525600, label: t('settings_hidden_groups_auto_hide_12_months') },
]

export const formatMinutes = (mins) => {
	const d = moment.duration(mins, 'minutes')
	const days = Math.floor(d.asDays())
	const hours = d.hours()
	const minutes = d.minutes()
	const parts = []
	if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`)
	if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? 's' : ''}`)
	if (minutes > 0) parts.push(`${minutes} min${minutes !== 1 ? 's' : ''}`)
	return parts.join(', ') || '0 mins'
}

export const getAutoHideOptionsWithFallback = (t, value) => {
	const options = getAutoHideOptions(t)
	if (options.some((o) => o.id === value)) {
		return options
	}
	return [...options, { id: value, label: formatMinutes(value) }]
}
